"use client";
import React, { useEffect, useRef } from 'react';

const pillars = [
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="url(#grad1)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <defs>
          <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#00c2ff" />
            <stop offset="100%" stopColor="#1a56b0" />
          </linearGradient>
        </defs>
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      </svg>
    ),
    title: '100% Qatari Owned',
    desc: 'Proudly rooted in Qatar, operating under full Qatari ownership since 2004 — aligned with national vision and local regulations.',
  },
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="url(#grad2)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <defs>
          <linearGradient id="grad2" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#00c2ff" />
            <stop offset="100%" stopColor="#1a56b0" />
          </linearGradient>
        </defs>
        <circle cx="12" cy="12" r="10" />
        <line x1="2" y1="12" x2="22" y2="12" />
        <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
      </svg>
    ),
    title: 'Global Talent Network',
    desc: 'Access to 50,000+ pre-qualified professionals sourced from 15+ countries, ready for rapid deployment across all skill levels.',
  },
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="url(#grad3)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <defs>
          <linearGradient id="grad3" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#00c2ff" />
            <stop offset="100%" stopColor="#1a56b0" />
          </linearGradient>
        </defs>
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    ),
    title: 'End-to-End HR Solutions',
    desc: 'From initial sourcing and visa processing to on-site management and compliance — a single partner for your entire workforce lifecycle.',
  },
];

export default function IntroStrip() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.reveal-hidden').forEach((el) => {
              el.classList.add('revealed');
            });
          }
        });
      },
      { threshold: 0.2 }
    );
    if (ref?.current) observer?.observe(ref?.current);
    return () => observer?.disconnect();
  }, []);

  return (
    <section ref={ref} className="relative py-16" style={{ background: '#071e3d' }}>
      <div className="max-w-[1280px] mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-0 divide-y md:divide-y-0 md:divide-x divide-[rgba(255,255,255,0.06)]">
          {pillars?.map((p, i) => (
            <div
              key={p?.title}
              className={`reveal-hidden stagger-${i + 1} flex items-start gap-5 px-8 py-8 first:pl-0 last:pr-0 group`}
            >
              <div
                className="w-14 h-14 rounded-xl flex items-center justify-center flex-shrink-0 transition-all duration-300 group-hover:scale-110"
                style={{
                  background: 'rgba(0,194,255,0.08)',
                  border: '1px solid rgba(0,194,255,0.2)',
                  boxShadow: '0 0 20px rgba(0,194,255,0.1)',
                }}
              >
                {p?.icon}
              </div>
              <div>
                <h3
                  className="text-fg font-bold text-base mb-2"
                  style={{ fontFamily: 'Syne, sans-serif' }}
                >
                  {p?.title}
                </h3>
                <p className="text-muted text-sm leading-relaxed" style={{ fontFamily: 'Plus Jakarta Sans, sans-serif', fontWeight: 300 }}>
                  {p?.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Cyan divider */}
      <div className="cyan-divider absolute bottom-0 left-0 right-0" />
    </section>
  );
}